<div class="qa-variable-search" *ngIf="getFormulaVariableNames(false).length">
  <i class="fa fa-search" aria-hidden="true"></i>
  <input type="search" class="form-control" [placeholder]="_(KEYS.EDITOR.SEARCH_FORMULA)" [attr.aria-label]="_(KEYS.EDITOR.SEARCH_FORMULA)"
         autocomplete="off" spellcheck="false" [(ngModel)]="search" [ngModelOptions]="{standalone: true}">
  <button type="button" class="qa-formula-toggle-all" (click)="toggleAllFormulas()">
    <i class="fa" [ngClass]="allFormulasOpen ? 'fa-compress' : 'fa-expand'" aria-hidden="true"></i>
    {{allFormulasOpen ? _(KEYS.EDITOR.COLLAPSE_ALL_FORMULAS) : _(KEYS.EDITOR.EXPAND_ALL_FORMULAS)}}
  </button>
</div>

<form [formGroup]="form" class="mt-1">
  <div class="formula-variable-container" *ngFor="let formulaVarName of getFormulaVariableNames(false)" [hidden]="!matchesSearch(formulaVarName)">
    <div class="formula-variable-content" [class.is-open]="isFormulaOpen(formulaVarName)" [class.has-error]="hasFormulaError(formulaVarName)"
         [ngClass]="{'dirty-entry': form.get(formulaVarName).dirty || form.get('expression:' + formulaVarName).dirty}">

      <!-- compact summary: name, formula preview and state; a click shows the editor -->
      <button type="button" class="qa-formula-summary" (click)="toggleFormula(formulaVarName)" [attr.aria-expanded]="isFormulaOpen(formulaVarName)">
        <i class="fa fa-chevron-right qa-formula-chevron" aria-hidden="true"></i>
        <span class="qa-formula-name">{{formulaVarName}}</span>
        <span class="qa-formula-badge qa-formula-badge-error" *ngIf="hasFormulaError(formulaVarName)" [attr.title]="getFormulaErrorText(formulaVarName)">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{_(KEYS.EDITOR.ERROR)}}
        </span>
        <code class="qa-formula-preview" [class.qa-formula-preview-empty]="!form.get('expression:' + formulaVarName).value">
          {{form.get('expression:' + formulaVarName).value || _(KEYS.EDITOR.FORMULA_EMPTY)}}
        </code>
        <span class="qa-formula-used" *ngIf="usedBy[formulaVarName]?.length" [attr.title]="usedBy[formulaVarName].join(', ')">
          <i class="fa fa-level-up" aria-hidden="true"></i> {{_(KEYS.EDITOR.FORMULA_USED_BY)}} {{usedBy[formulaVarName].join(', ')}}
        </span>
        <span class="qa-formula-badge qa-formula-badge-dirty" *ngIf="form.get(formulaVarName).dirty || form.get('expression:' + formulaVarName).dirty">
          {{_(KEYS.EDITOR.FORMULA_UNSAVED)}}
        </span>
      </button>

      <div class="qa-formula-body" *ngIf="isFormulaOpen(formulaVarName)">
      <!-- name input and buttons row -->
      <div class="name-and-buttons-row">
        <div class="input-group name-input-group">
          <span class="input-group-addon">Name</span>
          <input
            [value]="formulaVarName"
            id="{{formulaVarName}}"
            name="{{formulaVarName}}"
            [formControlName]='formulaVarName'
            [class.is-invalid]="!!nameError(formulaVarName)"
            (keydown)="onNameKeyDown($event, formulaInputEl, formulaVarName)"
            class="form-control"
            spellcheck="false"
            autocomplete="off"
            #formulaInputEl
          >
        </div>

        <div class="buttons-group">
          <button type="button"
            class="qa-icon-btn qa-icon-btn-save" [attr.aria-label]="_(KEYS.EDITOR.SAVE_VARIABLE)"
            [disabled]="(form.get(formulaVarName).errors || form.get('expression:' + formulaVarName).errors || !form.dirty)  ? true : null"
            (click)="onEdit(formulaInputEl.value, formulaVarName)"
          >
            <i class="fa fa-check" aria-hidden="true"></i>
          </button>
          <button type="button" class="qa-icon-btn" [attr.aria-label]="_(KEYS.EDITOR.RESET_VARIABLE)" [attr.title]="_(KEYS.EDITOR.RESET_VARIABLE)" (click)="onUndo(formulaVarName)">
            <i class="fa fa-undo"></i>
          </button>
          <button type="button" class="qa-icon-btn qa-icon-btn-danger" [attr.aria-label]="_(KEYS.EDITOR.DELETE_VARIABLE)" [attr.title]="_(KEYS.EDITOR.DELETE_VARIABLE)" (click)="onRemove(formulaVarName)">
            <i class="fa fa-trash"></i>
          </button>
          <button type="button"
            class="qa-icon-btn"
            [disabled]="!isFormulaFixable(formulaVarName)"
            title="{{_(KEYS.EDITOR.FORMULA_AUTOFIX)}}"
            (click)="onAutoFix(formulaVarName)"
          >
            <i class="fa fa-magic"></i>
          </button>
        </div>
      </div>
      <p class="qa-variable-msg qa-variable-msg-error" *ngIf="nameError(formulaVarName) as error" role="alert">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{error}}
      </p>

      <app-qa-formula-input [value]="form.get('expression:' + formulaVarName).value"
        [variables]="formulaSources" [errorRange]="formulaErrorRange(formulaVarName)"
        (saveRequested)="saveFormula(formulaVarName)"
        (valueChange)="onExpressionChange(formulaVarName, $event)"></app-qa-formula-input>

      <!-- error box for this formula -->
      <div class="alert alert-danger formula-error-box" *ngIf="hasFormulaError(formulaVarName)">
        <i class="fa fa-exclamation-triangle"></i> {{getFormulaErrorText(formulaVarName)}}
      </div>
      </div>

    </div>
  </div>
  <p *ngIf="search && !hasSearchResults()" class="qa-variable-search-empty">{{_(KEYS.EDITOR.NO_MATCHING_VARIABLES)}}</p>
</form>

<button type="button" class="qa-add-variable" (click)="onAdd()">
  <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.EDITOR.ADD_FORMULA_VARIABLE)}}
</button>
